module.exports = __webpack_public_path__ + "mo/img/process_1.476ecd4c.png";